module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/shared/promos/2022/blackfriday_mobile_nobg.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/shared/promos/2022/blackfriday_mobile_nobg.png
// module id = 4S0F
// module chunks = 0